import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy route — workspace items are managed on the main POS Workspaces page. */
const DsokPosWorkspaceNewPage = () => (
  <Navigate to="/customer/dsok/pos/workspaces" replace />
);

export default DsokPosWorkspaceNewPage;
